import { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import Swal from "sweetalert2";

import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import Button from "../../components/Button/Button";
import Select from "../../components/Input/Select/Select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import DailyMissionSettingCreate from "./DailyMissionSettingCreate";
import DailyMissionSettingEdit from "./DailyMissionSettingEdit";
import DailyMissionSettingListing from "./DailyMissionSettingListing";

import { getDailyMissionSetting, statusDailyMissionSetting } from "../../store/ducks/dailyMission/actions";

class DailyMissionSetting extends Component {
    constructor(props){
        super(props);
        this.state = {
            loading: true,
            pageShow: "listing",
            /* datatables / pagination */
            page: 1,
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            totalPages: 0,
            activePage: 1,
            totalRecords: 0,
            /* API result array */
            data: [],
            popupLoading: false,
            editId: null,
            permission: []
        }
    }

    componentDidMount(){
        const listingArr = this.fetchData();
        this.props.getDailyMissionSetting(listingArr);
    }

    shouldComponentUpdate(nextProps, nextState){
        if(nextState.permission.length===0 && this.props.currentPermission!==undefined){
            this.setState({ permission: this.props.currentPermission });
        }

        if(nextProps.daily_mission_setting!==undefined && nextProps.daily_mission_setting!==this.props.daily_mission_setting){
            if(nextProps.daily_mission_setting.data.responseCode===200 && nextProps.daily_mission_setting.data.msgType==="success"){
                this.setState({
                    loading: false,
                    data: nextProps.daily_mission_setting.data.data.result.row,
                    totalRecords: nextProps.daily_mission_setting.data.data.result.pagination.total_record,
                    totalPages: nextProps.daily_mission_setting.data.data.result.pagination.total_page
                });
            }
        }

        if(nextProps.daily_mission_setting_status!==undefined && nextProps.daily_mission_setting_status!==this.props.daily_mission_setting_status){
            if(nextProps.daily_mission_setting_status.data.responseCode===200 && nextProps.daily_mission_setting_status.data.msgType==="success"){
                const { t } = this.props;
                Swal.fire({
                    icon: 'success',
                    title: t('global.success'),
                    html: t('global.record-updated'),
                    showConfirmButton: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.setState({ loading: true });
                        this.refreshHandler();
                    }
                });
            } else{
                this.setState({ loading: false });
                const { t } = this.props;
                Swal.fire({
                    title: t("global.something-wrong"),
                    icon: nextProps.daily_mission_setting_status.data.msgType,
                    confirmButtonText: t("global.ok"),
                });
            }
        }
        return true;
    }

    fetchData = () => {
        const listingArr = {};
        let availablePage = this.state.activePage;

        if (this.state.totalRecords !== 0) {
            availablePage = parseInt((this.state.totalRecords / this.state.limit) + 1);
            (this.state.activePage >= availablePage) && this.setState({ activePage: availablePage});
        }

        listingArr.page = (this.state.activePage >= availablePage) ? availablePage : this.state.activePage;
        listingArr.limit = this.state.limit;
        return listingArr;
    }

    refreshHandler = () => {
        const listingArr = this.fetchData();
        this.props.getDailyMissionSetting(listingArr);
    }
    
    editHandler = (e, id) => {
        e.preventDefault();
        this.setState({
            editId: id,
            pageShow: "edit",
        });
    }

    changePageHandler = (page) => {
        this.setState({
            pageShow: page
        });
    }

    updateStatus = (event, id) => {
        event.preventDefault();
        const { t } = this.props;
        Swal.fire({
            title: t("global.confirmation"),
            text: t("global.are-you-sure"),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t("global.update"),
            cancelButtonText: t("global.cancel"),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: '',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    onOpen: () => {
                        Swal.showLoading()
                    }
                });

                const data = {};
                data.id = id;
                data.status = Number(event.target.value);
                // console.log("Update Status",data);
                this.props.statusDailyMissionSetting(data);
            }
        });
    }

    // datatable function
    datatablesChangeHandler = (val, act) => {
        this.setState({
            [act]: act === "searchValue" ? val.target.value : val,
        }, () => {
            const listingArr = this.fetchData();
            this.props.getDailyMissionSetting(listingArr);
        });
    }
    
    noFormatter = (cell, row, rowIndex) => {
        let rowNumber = (this.state.activePage - 1) * this.state.limit + (rowIndex + 1);
        return <span>{rowNumber}</span>;
    }

    changeStatusFormatter = (cell, row) => {
        const { t } = this.props;

        if (this.state.permission.includes("daily_mission_setting_update")) {
            let statusArray, dtClassName;
            statusArray = [
                {
                    label: t("global.active"),
                    value: 1,
                    selected: true,
                },
                {
                    label: t("global.inactive"),
                    value: 0,
                },
            ];

            if (row.status === 0) {
                dtClassName = "form-control datatable-select-inactive";
            } else {
                dtClassName = "form-control datatable-select-active";
            }

            return (
                <Select
                    id="status"
                    name="status"
                    options={statusArray}
                    defaultValue={row.status}
                    key={`status-${row.Id}`}
                    onChange={(event) => {
                        this.updateStatus(event, row.Id)
                    }}
                    className={dtClassName}
                />
            )
        }else{
            let badgeClassName, status;
            if (row.status === 0 || null) {
                badgeClassName = "badge badge-pill badge-danger";
                status = t("global.inactive");
            } else {
                badgeClassName = "badge badge-pill badge-success";
                status = t("global.active");
            }
            return (
                <span className={badgeClassName} key={Math.random()}>{status}</span>
            )
        }
    }
    
    actionFormatter = (cell, row) => {
        let editButton, output;

        if (this.state.permission.includes("daily_mission_setting_update")) {
            editButton = (
                <Button
                    typeButton="button"
                    classValue="btn btn-sm btn-white"
                    key={`edit-${row.Id}`}
                    idValue={row.Id === undefined ? 0 : row.Id}
                    clicked={(event) => this.editHandler(event, row.Id)}
                    buttonName={<FontAwesomeIcon icon={faPen} />}
                />
            );
        }

        output = [editButton];
        return output;
    }

    settingValueFormatter = (cell, row) => {
        const { t } = this.props;
        let settingValue = JSON.parse(row.bonusSetting);
        // console.log(settingValue,typeof(settingValue));
        let output = [];
        for(var key in settingValue){
            let sub_output = [];
            for(var sub_key in settingValue[key]){
                sub_output.push(<span key={Math.random()}><br />{t(`daily-mission-setting.${sub_key.replace("_","-")}`)} - {settingValue[key][sub_key]}</span>);
            }
            output.push(<span className="badge badge-primary mr-2 mb-1 mt-1" key={key}>{key} : {sub_output}</span>)
        }
        return output;
    }

    render(){
        const { t } = this.props;
        const columns = [
            { text: t("global.no"), dataField: "no", formatter: this.noFormatter, headerStyle: { width: "60px" } },
            { text: t("daily-mission-setting.slug"), dataField: "slug" },
            { text: t("daily-mission-setting.days-per-cycle"), dataField: "daysPerCycle" },
            { text: t("daily-mission-setting.daily-start-time"), dataField: "dailyStartTime" },
            { text: t("daily-mission-setting.daily-end-time"), dataField: "dailyEndTime" },
            { text: t("daily-mission-setting.bonus-setting"), dataField: "bonusSetting", formatter: this.settingValueFormatter, headerStyle: {width: "250px"} },
            { text: t("daily-mission-setting.updated-at"), dataField: "updatedAt" },
            { text: t("daily-mission-setting.updated-by"), dataField: "updatedBy" },
            { text: t("daily-mission-setting.status"), dataField: "status", formatter: this.changeStatusFormatter, headerStyle: { width: "115px"} },
            { text: t("global.action"), dataField: "#", formatter: this.actionFormatter, headerStyle: { width: "65px" } },
        ];

        let dataListing = this.state.data.map((val, idx) => {
            return {
                Id: val.Id,
                slug: val.slug,
                daysPerCycle: val.daysPerCycle,
                dailyStartTime: val.dailyStartTime,
                dailyEndTime: val.dailyEndTime,
                bonusSetting: val.bonusSetting,
                updatedAt: val.updatedAt,
                updatedBy: val.username,
                status: val.status
            }
        });

        return (
            <Auxiliary>
                {this.state.pageShow==="listing" && (
                    <DailyMissionSettingListing
                        changePageHandler={(page) => this.changePageHandler(page)}
                        datatablesChangeHandler={(val, act) => this.datatablesChangeHandler(val, act)}
                        columns={columns}
                        dataListing={dataListing}
                        activePage={this.state.activePage}
                        limit={this.state.limit}
                        totalRecords={this.state.totalRecords}
                        loading={this.state.loading}
                        permission={this.state.permission}
                    />
                )}

                {this.state.permission.includes("daily_mission_setting_create") && this.state.pageShow==="create" && (
                    <DailyMissionSettingCreate 
                        changePageHandler={(page) => this.changePageHandler(page)}
                        refreshHandler={() => this.refreshHandler()}
                    />
                )}

                {this.state.permission.includes("daily_mission_setting_update") && this.state.pageShow==="edit" && (
                    <DailyMissionSettingEdit
                        editId={this.state.editId}
                        changePageHandler={(page) => this.changePageHandler(page)}
                        refreshHandler={() => this.refreshHandler()}
                    />
                )}
            </Auxiliary>
        );
    }
}

const mapStateToProps = state => {
    return {
        currentPermission: state.currentUser.data.permission,
        daily_mission_setting: state.dailyMission.daily_mission_setting,
        daily_mission_setting_status: state.dailyMission.daily_mission_setting_status
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getDailyMissionSetting: (data) => dispatch(getDailyMissionSetting(data)),
        statusDailyMissionSetting: (data) => dispatch(statusDailyMissionSetting(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(DailyMissionSetting));